import CnOneSearch from './cn-one-search';
import { formatSuggestionsApiResponse } from './utils';
import { useCnOneSearch } from './plugins/use-cn-one-search';
import useVersionSwitch from './use-version-switch';
const version = '0.6.18';
export { formatSuggestionsApiResponse, useCnOneSearch, version, useVersionSwitch, };
export default CnOneSearch;
